export const NOTUNREPORTED = "NotUnreported";
export const UNREPORTED = "Unreported";
export const CALENDARIZATION_WEIGHTED = "weighted";
export const CALENDARIZATION_DAILY = "daily";

import { environment } from "src/environments/environment";
export const NTM_STM_OPTIONS = [
  {
    id: NOTUNREPORTED,
    label: "Rolling 365 Days ",
    info: {
      description:
        "“Rolling 365 Days” calculates the value for the Next Twelve Months (NTM, starting tomorrow) or the Second Twelve Months (STM, starting a year from tomorrow) as a daily, time-weighted interpolation of the relevant current or upcoming fiscal periods, reported or not. Whether Interim or Annual estimates are used in the interpolation is based on the Calendarization Method you have selected. Our support site further illustrates this with examples ",
      link:
        environment.SUPPORT_LINKS.base_link +
        environment.SUPPORT_LINKS +
        environment.SUPPORT_LINKS.articles.calendarization_methods,
    },
  },
  {
    id: UNREPORTED,
    label: "Unreported Periods",
    info: {
      description:
        "“Unreported Periods (Interims Only)” calculates the Next Twelve Months (NTM) or the Second Twelve Months (STM) as the sum of either the next four unreported quarters (or the following four for STM), or the next two unreported semi-annual periods (or the following two for STM). Note that NTM includes the current interim period which may have already concluded if the company has yet to report its results. The Calendarization Method you have selected is ignored and only quarterly or semi-annual periods are used in this calculation. No result is provided if only Annual forecasts for the company are available. Our support site further illustrates this with examples ",
      link:
        environment.SUPPORT_LINKS.base_link +
        environment.SUPPORT_LINKS +
        environment.SUPPORT_LINKS.articles.calendarization_methods,
    },
  },
];

export const CALENDARIZATION_OPTIONS = [
  {
    id: CALENDARIZATION_DAILY,
    label: "Annual Interpolation",
  },
  {
    id: CALENDARIZATION_WEIGHTED,
    label: "Adjusted Interims (as available)",
  },
];

export const GLOBAL_SETTINGS_MODAL = "GLOBAL_SETTINGS_MODAL";

export const GLOBAL_SETTINGS_LOG_ACTION_FEATURES = {
  updateGlobalPeriodSettings: "UPDATE_GLOBAL_PERIOD_SETTINGS",
};
